export enum ProcurementHistoricalActionEnum {
	CartChekout = 1,
	JobChekout = 2,
	CartChekoutTotalLoss = 3,
	PartStatusChanged = 4,
	OrderStatusChanged = 5,
	ReassignedOrder = 6,
	SubOrderStatusChanged = 7,
	PartStatusChangedReassing = 8,
	EditedOrderPrice = 9,
	InvoiceEdited = 14,
	ShippingCostsChanged = 18,
	DeliveryDateUpdated = 19,
	Requoted = 20,
	SupplierWasEvaluated = 21,
	PaymentVoucher = 28,
	cancelledPartsWereReverted = 29,
	MarkedForLaterCancel = 30,
	SendUpdatesManuallyQueued = 31,
}
